import { render } from "./EditProfile.vue?vue&type=template&id=50b5264a&scoped=true&lang=pug"
import script from "./EditProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfile.vue?vue&type=script&setup=true&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=50b5264a&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b5264a"]])

export default __exports__